var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZapierLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 135.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zapier logo - Brandlogos.net") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M251.42,409.1l-.07-.22,44.46-40.7V348.56H224.48v19.61h42.6l.07.19-44,40.73v19.61h73.39V409.1Z",
    transform: "translate(-134 -316.25)",
    style: {
      fill: "#201515"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.3,346.7q-12.34,0-20.12,3.72a26.4,26.4,0,0,0-11.67,10.23,37.24,37.24,0,0,0-4.9,14.8l21.64,3q1.17-6.92,4.7-9.81a14.34,14.34,0,0,1,9.3-2.88q6.59,0,9.56,3.52c2,2.35,3,5.6,3,9.89v2.14H331q-15.89,0-22.83,7T301.21,407q0,11.84,6.93,17.61t17.43,5.74q13,0,20-9A33.3,33.3,0,0,0,351.38,409h.79l3,19.61h19.61V379q0-15.39-8.11-23.85T340.3,346.7Zm6.86,61.21c-3.11,2.6-7.19,3.89-12.26,3.89q-6.27,0-8.71-2.2a7.17,7.17,0,0,1-2.45-5.58,7.33,7.33,0,0,1,2-5.41,7.55,7.55,0,0,1,5.58-2h20.47v1.35a12.45,12.45,0,0,1-4.65,10Z",
    transform: "translate(-134 -316.25)",
    style: {
      fill: "#201515"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.33,348.56H470.16v80.15h23.17Z",
    transform: "translate(-134 -316.25)",
    style: {
      fill: "#201515"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.11,348.56q-9.82,0-15.48,6.93-4.06,5-6.18,14.71h-.68l-3-21.64H585v80.14h23.17v-41.1q0-7.77,3.64-11.92t13.43-4.15H634v-23Z",
    transform: "translate(-134 -316.25)",
    style: {
      fill: "#201515"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562,351.18q-8.11-4.83-20.47-4.81-19.44,0-30.44,11.07T500.1,388a48.66,48.66,0,0,0,5,22.65,36,36,0,0,0,14.21,15q9.21,5.32,21.9,5.33,11,0,18.34-3.38a29.49,29.49,0,0,0,11.67-9.22,40.18,40.18,0,0,0,6.34-13.1l-20-5.59a18.47,18.47,0,0,1-4.7,8.13q-3.38,3.38-11.33,3.38-9.45,0-14.09-5.41c-2.24-2.61-3.65-6.33-4.27-11.16h54.66c.22-2.25.34-4.15.34-5.67v-5a44.5,44.5,0,0,0-4.05-19.45A30.43,30.43,0,0,0,562,351.18Zm-21.14,14.29q14.09,0,16,13.87H523.61a19.08,19.08,0,0,1,3.72-8.47Q531.9,365.46,540.86,365.47Z",
    transform: "translate(-134 -316.25)",
    style: {
      fill: "#201515"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482,316.26a13,13,0,0,0-9.48,3.64,12.55,12.55,0,0,0-3.72,9.39A12.74,12.74,0,0,0,482,342.48a12.53,12.53,0,0,0,9.39-3.72,12.92,12.92,0,0,0,3.63-9.46,12.46,12.46,0,0,0-13-13Z",
    transform: "translate(-134 -316.25)",
    style: {
      fill: "#201515"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.14,346.37q-11.84,0-19,7.43-5.32,5.51-7.81,16.44h-.74l-3-21.64H383.76V451.75h23.17V409.26h.85a43.3,43.3,0,0,0,3,8.22,23.33,23.33,0,0,0,9.22,10.31,27.08,27.08,0,0,0,13.69,3.3q14.55,0,22.16-11.33t7.61-31.62q0-19.6-7.36-30.68T434.14,346.37Zm2.35,58.08q-4.05,5.87-12.68,5.87a14.95,14.95,0,0,1-12.42-5.67q-4.5-5.65-4.49-15.46v-1.53q0-10,4.49-15.27t12.42-5.24q8.78,0,12.76,5.58t4,15.56q0,10.32-4,16.16Z",
    transform: "translate(-134 -316.25)",
    style: {
      fill: "#201515"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.16,409.1H134v19.63h80.15Z",
    transform: "translate(-134 -316.25)",
    style: {
      fill: "#ff4f00"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapierLogo);
export default __webpack_public_path__ + "static/media/zapierLogo.d3ea369547148e3ea247209f13693e6a.svg";
export { ForwardRef as ReactComponent };